const anonymous = true // 登录鉴权元信息
const requiresAuth = true // 身份验证元信息
const keepAlive = true // keep-alive 缓存
const ADMIN_Routes = {
  path: '/admin/:group',
  name: 'adminFrame',
  props: true,
  component: () => import('@components/Frame.vue'),
  meta: { anonymous, requiresAuth },
  children: [
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 基础管理——本机构信息
       */
      path: 'currentOrg',
      component: () => import('/src/views/admin/base/currentOrg/index.vue'),
      breadcrumbName: '本机构信息',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 基础管理——本机构信息-> 编辑机构信息
       */
      path: 'currentOrg/edit/:orgId',
      component: () => import('/src/views/admin/base/currentOrg/edit.vue'),
      props: true,
      breadcrumbName: '编辑机构信息',
      meta: { requiresAuth, funPath: '/base/currentOrg' }
    },
    {
      /**
       * @description: 基础管理——机构管理--机构信息管理
       */
      path: 'orgManage/orgInfo',
      component: () => import('/src/views/admin/base/orgManage/index.vue'),
      breadcrumbName: '机构信息管理',
      meta: { requiresAuth, keepAlive,funPath: '/admin/base/orgManage' }
    },
    {
      /**s
       * @description: 基础管理——机构管理--机构信息管理  -> 新增机构
       */
      path: 'orgManage/orgInfo/add',
      component: () => import('/src/views/admin/base/orgManage/addOrEdit.vue'),
      breadcrumbName: '新增机构',
      meta: { requiresAuth, funPath: '/admin/base/orgManage' }
    },
    {
      /**
       * @description: 基础管理——机构管理--机构信息管理 -> 编辑机构
       */
      path: 'orgManage/orgInfo/edit/:orgId',
      component: () => import('/src/views/admin/base/orgManage/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑机构',
      meta: { requiresAuth, funPath: '/base/orgManage' }
    },
    {
      /**
       * @description: 基础管理——机构管理--机构信息管理  -> 查看机构
       */
      path: 'orgManage/orgInfo/detail/:orgId',
      component: () => import('/src/views/admin/base/orgManage/check.vue'),
      props: true,
      breadcrumbName: '查看机构',
      meta: { requiresAuth, funPath: '/base/orgManage' }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 基础管理——组织结构管理
       */
      path: 'departmentManage',
      component: () => import('/src/views/admin/base/departmentManage/index.vue'),
      breadcrumbName: '组织结构管理',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 基础管理——组织结构管理->添加成员
       */
      path: 'departmentManage/member/:id',
      component: () => import('/src/views/admin/base/departmentManage/member.vue'),
      props: true,
      breadcrumbName: '管理成员',
      meta: { requiresAuth, funPath: '/base/departmentManage' }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 基础管理——用户管理
       */
      path: 'user',
      component: () => import('/src/views/admin/base/user'),
      breadcrumbName: '用户管理',
      meta: { requiresAuth, funPath: '/base/user', keepAlive }
    },
    {
      /**
       * @description: 基础管理——用户管理——新增用户
       */
      path: 'user/add',
      component: () => import('/src/views/admin/base/user/addOrEdit.vue'),
      breadcrumbName: '新增用户',
      meta: { requiresAuth, funPath: '/base/user', keepAlive }
    },
    {
      /**
       * @description: 基础管理——用户管理——编辑用户
       */
      path: 'user/edit/:id',
      component: () => import('/src/views/admin/base/user/addOrEdit.vue'),
      breadcrumbName: '编辑用户',
      props: true,
      meta: { requiresAuth, funPath: '/base/user', keepAlive }
    },
    // ---------------------------------------------------------------- //

    {
      /**
       * @description: 基础管理——角色管理
       */
      path: 'role',
      component: () => import('/src/views/admin/base/role/index.vue'),
      breadcrumbName: '角色管理',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 基础管理——角色管理 -> 新增角色
       */
      path: 'role/add',
      component: () => import('/src/views/admin/base/role/addOrEdit.vue'),
      breadcrumbName: '新增角色',
      meta: { requiresAuth, funPath: '/base/role' }
    },
    {
      /**
       * @description: 基础管理——角色管理 -> 编辑角色
       */
      path: 'role/edit/:recordUid',
      component: () => import('/src/views/admin/base/role/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑角色',
      meta: { requiresAuth, funPath: '/base/role' }
    },
    {
      /**
       * @description: 基础管理——角色管理 -> 管理成员
       */
      path: 'role/members/:id',
      component: () => import('/src/views/admin/base/role/roleMember.vue'),
      props: true,
      breadcrumbName: '管理成员',
      meta: { requiresAuth, funPath: '/base/role', keepAlive }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育赛事——线上赛管理——竞技排名赛
       */
      path: 'onlineManagement/competitionRank',
      component: () => import('/src/views/admin/sportsGame/onlineManagement/competitionRank'),
      breadcrumbName: '竞技排名赛',
      meta: { requiresAuth, funPath: '/admin/sportsGame/onlineManagement', keepAlive }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——竞技排名赛-> 新增竞技排名赛
       */
      path: 'onlineManagement/competitionRank/addRank',
      component: () =>
        import('/src/views/admin/sportsGame/onlineManagement/competitionRank/addOrEdit.vue'),
      breadcrumbName: '新增竞技排名赛',
      meta: { requiresAuth, funPath: '/admin/sportsGame/onlineManagement' }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——竞技排名赛-> 编辑竞技排名赛
       */
      path: 'onlineManagement/competitionRank/editRank/:id',
      component: () =>
        import('/src/views/admin/sportsGame/onlineManagement/competitionRank/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑竞技排名赛',
      meta: { requiresAuth, funPath: '/admin/sportsGame/onlineManagement' }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——竞技排名赛-> 竞技排名赛详情
       */
      path: 'onlineManagement/competitionRank/detailRank/:id',
      component: () =>
        import('/src/views/admin/sportsGame/onlineManagement/competitionRank/addOrEdit.vue'),
      props: true,
      breadcrumbName: '竞技排名赛详情',
      meta: { requiresAuth, funPath: '/admin/sportsGame/onlineManagement' }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——竞技排名赛-> 竞技排名赛数据
       */
      path: 'onlineManagement/competitionRank/dataRank/:id',
      component: () => import('/src/views/admin/sportsGame/onlineManagement/competitionRankData'),
      props: true,
      breadcrumbName: '竞技排名赛数据',
      meta: { requiresAuth, funPath: '/admin/sportsGame/onlineManagement' }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育教学——体育家庭作业——作业管理
       */
      path: 'sportsHomework/homeworkManagement',
      component: () => import('/src/views/admin/sportsTeach/sportsHomework/homeworkManagement'),
      breadcrumbName: '作业管理',
      meta: { requiresAuth, funPath: '/admin/sportsTeach/sportsHomework', keepAlive }
    },
    {
      /**
       * @description: 体育教学——体育家庭作业——作业管理-> 详情
       */
      path: 'sportsHomework/homeworkManagement/detail/:id',
      component: () =>
        import('/src/views/admin/sportsTeach/sportsHomework/homeworkManagement/addOrEdit.vue'),
      props: true,
      breadcrumbName: '作业详情',
      meta: { requiresAuth, funPath: '/admin/sportsTeach/sportsHomework' }
    },
    {
      /**
       * @description: 体育教学——体育课堂——随堂练列表
       */
      path: 'class/practise',
      component: () => import('/src/views/admin/sportsTeach/class/practise'),
      props: true,
      breadcrumbName: '随堂练',
      meta: { requiresAuth, funPath: '/admin/sportsTeach/class', keepAlive }
    },
    {
      /**
       * @description: 体育教学——体育课堂——随堂测列表
       */
      path: 'class/test',
      component: () => import('/src/views/admin/sportsTeach/class/test'),
      props: true,
      breadcrumbName: '随堂测',
      meta: { requiresAuth, funPath: '/admin/sportsTeach/class', keepAlive }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育测试——组织测试——测试管理
       */
      path: 'organizeTest/testManage',
      component: () => import('/src/views/admin/sportTest/organizeTest/testManage/index.vue'),
      breadcrumbName: '测试管理',
      meta: { requiresAuth, funPath: '/admin/sportTest/organizeTest', keepAlive }
    },
    {
      /**
       * @description: 体育测试——组织测试——测试管理--新增计划
       */
      path: 'organizeTest/testManage/add',
      component: () => import('/src/views/admin/sportTest/organizeTest/testManage/addOrEdit.vue'),
      breadcrumbName: '新增计划',
      meta: { requiresAuth, funPath: '/admin/sportTest/organizeTest' }
    },
    {
      /**
       * @description: 体育测试——组织测试——测试管理--查看计划
       */
      path: 'organizeTest/testManage/check/:id',
      component: () => import('/src/views/admin/sportTest/organizeTest/testManage/checkPlan.vue'),
      props: true,
      breadcrumbName: '查看计划',
      meta: { requiresAuth, funPath: '/admin/sportTest/organizeTest' }
    },
    {
      /**
       * @description: 体育测试——组织测试——成绩查询
       */
      path: 'organizeTest/scoreSearch',
      component: () => import('/src/views/admin/sportTest/organizeTest/scoreSearch/index.vue'),
      breadcrumbName: '成绩查询',
      meta: { requiresAuth, funPath: '/admin/sportTest/organizeTest', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育测试——自主测试——测试记录
       */
      path: 'selfTest/testRecord',
      component: () => import('/src/views/admin/sportTest/selfTest/testRecord/index.vue'),
      breadcrumbName: '测试记录',
      meta: { requiresAuth, funPath: '/admin/sportTest/selfTest', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育锻炼——锻炼记录——自由锻炼
       */
      path: 'exerciseRecord/freeExercise',
      component: () => import('/src/views/admin/sportExercise/exerciseRecord/index.vue'),
      breadcrumbName: '自由锻炼',
      meta: { requiresAuth, funPath: '/admin/sportExercise/exerciseRecord', keepAlive }
    },
    {
      /**
       * @description: 体育锻炼——锻炼记录--趣味锻炼
       */
      path: 'exerciseRecord/funExercise',
      component: () => import('/src/views/admin/sportExercise/exerciseRecord/indexFun.vue'),
      breadcrumbName: '趣味锻炼',
      meta: { requiresAuth, funPath: '/admin/sportExercise/exerciseRecord', keepAlive }
    },
    {
      /**
       * @description: 体育锻炼——锻炼记录--竞技场
       */
      path: 'exerciseRecord/arena',
      component: () => import('/src/views/admin/sportExercise/exerciseRecord/indexArena.vue'),
      breadcrumbName: '竞技场',
      meta: { requiresAuth, funPath: '/admin/sportExercise/exerciseRecord', keepAlive }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 运营运维中心——banner——banner
       */
      path: 'banner/bannerConfig',
      component: () => import('/src/views/admin/resources/banner/index.vue'),
      breadcrumbName: 'Banner配置',
      meta: { requiresAuth, funPath: '/admin/resources/banner', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心——banner—— -> 新增编辑
       */
      path: 'banner/bannerConfig/edit/:uid',
      component: () => import('/src/views/admin/resources/banner/editBanner.vue'),
      props: true,
      breadcrumbName: '编辑Banner配置',
      meta: { requiresAuth, funPath: '/admin/resources/banner' }
    },
    {
      /**
       * @description: 运营运维中心——banner—— -> 查看
       */
      path: 'banner/bannerConfig/detail/:uid',
      component: () => import('/src/views/admin/resources/banner/lookBanner.vue'),
      props: true,
      breadcrumbName: '查看Banner配置',
      meta: { requiresAuth, funPath: '/admin/resources/banner' }
    }
  ]
}

export default ADMIN_Routes
